import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OfferService } from '@services/cms/offer.service';
import { Offer } from '@models/offer';

@Component({
  selector: 'app-form-offer',
  templateUrl: './form-offer.component.html',
  styleUrls: ['./form-offer.component.scss']
})
export class FormOfferComponent implements OnInit {
  public subtitle: string;
  private create: boolean;

  constructor(
      public dialogRef: MatDialogRef<FormOfferComponent>,
      public service: OfferService,
      @Inject(MAT_DIALOG_DATA) public data: Offer
  ) {
    // console.log(data);
    this.subtitle = this.service.modelClass.langBase + 'createEditSubtitle';
    this.service.modelClass.model = data;
    this.create = this.service.modelClass.model.offertID === 0;
    if (this.service.modelClass.model['liveID'] > 0) {
      this.service.modelClass.formCells.filter(x => x.name === 'liveID')[0].disable = true;
    }
  }

  ngOnInit(): void {
  }

  sendForm(): void {
    const self = this;
    if (this.create) {
      self.service.create().then((response) => {
        if (response) {
          self.close(true);
        }
      });
    } else {
      self.service.update(self.service.modelClass.model[self.service.modelClass.idName]).then((response) => {
        if (response) {
          self.close(true);
        }
      });
    }
  }

  public close = (reload: boolean = false) => {
    this.dialogRef.close({ data: { reload }});
  }
}
